import { render, staticRenderFns } from "./updateTransferRegion.vue?vue&type=template&id=4cf68d1a&scoped=true&"
import script from "./updateTransferRegion.vue?vue&type=script&lang=ts&"
export * from "./updateTransferRegion.vue?vue&type=script&lang=ts&"
import style0 from "./updateTransferRegion.vue?vue&type=style&index=0&id=4cf68d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf68d1a",
  null
  
)

export default component.exports